import Button from "../../atoms/Button";
import Modal from "../Modal";
import { useId, type ReactNode } from "react";

export interface AlertModalAction {
  label: string;
  onClick: () => void;
}

export interface AlertModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: ReactNode;
  action?: AlertModalAction;
}

export function AlertModal({ open, onClose, title, description, action }: AlertModalProps) {
  const titleId = useId();
  const descId = useId();
  return (
    <Modal
      open={open}
      onClose={onClose}
      labelledBy={titleId}
      describedBy={description ? descId : undefined}
    >
      <h2 id={titleId} className="mb-4 text-lg font-semibold">
        {title}
      </h2>
      {description && (
        <div id={descId} className="mb-6 text-sm">
          {description}
        </div>
      )}
      <div className="flex justify-end gap-2">
        <Button variant="secondary" onClick={onClose}>
          Fermer
        </Button>
        {action && <Button onClick={action.onClick}>{action.label}</Button>}
      </div>
    </Modal>
  );
}

export default AlertModal;
